import React from 'react'

import dayjs, { Dayjs } from 'dayjs'
import 'dayjs/locale/de'

import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker'
import { renderTimeViewClock } from '@mui/x-date-pickers/timeViewRenderers'
import TextField from '@mui/material/TextField'

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    width: '100%',
  },
}))

interface IDatesProps {
  value?: Date
  onChangeDate?: (date: Date | null | undefined) => void
  timePicker?: boolean
  label?: string
  disabled?: boolean
  helperText?: string
  minDate?: Date
  maxDate?: Date
  inputVariant?: string
  fullWidth?: boolean
  size?: 'medium' | 'small'| undefined
  inputLabelShrink?: boolean
}

const DatePickerComponent: React.FC<IDatesProps> = (props) => {
  const classes = useStyles()

  const changeValue = (date: Dayjs | null) => {
    props.onChangeDate && props.onChangeDate(date?.toDate())
  }

  return (
    <div className={classes.root}>
      <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale='de'>
        {
          props.timePicker
            ? (
              <DateTimePicker
                label={props.label}
                value={props.value ? dayjs(props.value) : null}
                minDate={props.minDate ? dayjs(props.minDate) : undefined}
                maxDate={props.maxDate ? dayjs(props.maxDate) : undefined}
                disabled={props.disabled}
                onChange={changeValue}
                slotProps={{
                  textField: { size: props.size, InputLabelProps: { shrink: props.inputLabelShrink }, fullWidth: props.fullWidth }
                }}
                viewRenderers={{
                  hours: renderTimeViewClock,
                  minutes: renderTimeViewClock,
                  seconds: renderTimeViewClock,
                }}
              />
            )
            : (
              <DatePicker
                label={props.label}
                value={props.value ? dayjs(props.value) : null}
                onChange={changeValue}
                minDate={props.minDate ? dayjs(props.minDate) : undefined}
                maxDate={props.maxDate ? dayjs(props.maxDate) : undefined}
                disabled={props.disabled}
                slotProps={{
                  textField: { size: props.size, InputLabelProps: { shrink: props.inputLabelShrink }, fullWidth: props.fullWidth }
                }}
              />
            )
        }
      </LocalizationProvider>
    </div>
  )
}
export default DatePickerComponent
